import request from '@/utils/request'

// 销售管理
export const sale_list=(data)=>{
  return request({
    url: '/erp/home/sales-data',
    method: 'post',
    data
  })
}
// 销售货物详情
export const goods_detail=(data)=>{
  return request({
    url: '/erp/home/goods-detail',
    method: 'post',
    data
  })
}

// 销售批次统计详情
export const batch_detail=(data)=>{
  return request({
    url: '/erp/home/batch-count',
    method: 'post',
    data
  })
}
// 销售批次明细详情
export const batch_goods_detail=(data)=>{
  return request({
    url: '/erp/home/batch-detail',
    method: 'post',
    data
  })
}